// extracted by mini-css-extract-plugin
export default {"box":"Checkbox_box__MhjP1","wrapper":"Checkbox_wrapper__Bqip7","input":"Checkbox_input__j+rOG","icon":"Checkbox_icon__7IXDO","true":"Checkbox_true__WnsxQ"};